module.exports = __webpack_public_path__ + "static/media/How Frovo Works.9fd04cff.png";